"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var translations = [];
var defaultLanguage = 'en';
module.exports.init = function (_jsonFile, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(_jsonFile);
        const data = yield response.json();
        translations = data;
        defaultLanguage = yield callback();
    });
};
module.exports.t = function (_phrase) {
    var phrase = translations.find(function (p) {
        return p.en.toLowerCase() === _phrase.toLowerCase();
    });
    if (phrase === undefined) {
        return _phrase;
    }
    return phrase[defaultLanguage] === undefined
        ? _phrase
        : phrase[defaultLanguage];
};
